module.exports = __webpack_public_path__ + "static/media/logo-light.c92032cc.svg";